<div class="mech-diag-content">
	<div *ngIf="confidence" class="confidence">Prediction confidence: {{confidence}}</div>
	<app-dvs-chart [error]="errormessage" [options]="options" [height]="'400px'" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
	<div *ngIf="hasMaintenance" class="legend">
		<span class="legend-item">
			<span class="swatch" style="background-color: #f3f700"></span> Maintenance event
		</span>
	</div>
	<div class="trend-options">
		<div class="row justify-content-sm-center">
			<div class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label">
						<input [(ngModel)]="useXAxisDate" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						X-Axis by date
					</label>
				</div>
			</div>
			<div *ngIf="dataExceedsLimit" class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label" title="Chart is normally limited to the last 15k points. Viewing all data may could cause your browser to crash.">
						<input [(ngModel)]="unlimitedChart" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						Show all data
					</label>
				</div>
			</div>
			<div class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label">
						<input [(ngModel)]="forceRul" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						Force RUL calculation
					</label>
				</div>
			</div>
			<div *ngIf="forceRul && rul" class="col-sm-auto">
				RUL: {{rul | number : "1.0-2"}}
			</div>
		</div>
	</div>
</div>